/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReddIdOut
 */
export interface ReddIdOut {
    /**
     * 
     * @type {string}
     * @memberof ReddIdOut
     */
    reddId?: string;
    /**
     * 
     * @type {number}
     * @memberof ReddIdOut
     */
    propertyId: number;
}

export function ReddIdOutFromJSON(json: any): ReddIdOut {
    return ReddIdOutFromJSONTyped(json, false);
}

export function ReddIdOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReddIdOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reddId': !exists(json, 'reddId') ? undefined : json['reddId'],
        'propertyId': json['propertyId'],
    };
}

export function ReddIdOutToJSON(value?: ReddIdOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reddId': value.reddId,
        'propertyId': value.propertyId,
    };
}


